//============================================================================
// Redux
//============================================================================
export enum InvoicesActions {
  StoreInitialState,

  // Invoice Item
  ItemCreate,
  ItemDestroy,
  ItemDestroyAll,
  ItemUpdate,
}
